import React from 'react';
import { Grid } from '@material-ui/core';
import EirClearCart from './EirClearCart';
function EirReviewOrderHeader(props) {
    return (
        <Grid container className='top-pad'>
            <Grid item xs={9} sm={6}>
                <h1 id='review-order' className='review-order'>
                    Review your order
                </h1>
            </Grid>
            <Grid item sm={6}>
                <EirClearCart label='Clear Cart' link='#' details={props.details}></EirClearCart>
            </Grid>
        </Grid>
    );
}
export default EirReviewOrderHeader;